import { Plus } from "lucide-react";
import { useEffect, useState } from "react";
import { Button } from "@/shared/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/shared/components/ui/dialog";
import t from "@/lang/lang";
import { CommonDialogFooter } from "@/shared/components/dialog/dialog-common";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { TextInput } from "@/shared/components/form/text-input";
import {
  PutRequest,
  useCustomersCustomerPutMutation,
} from "@/services/backend/customers/api/customer-api";
import { createEntityId } from "@/shared/types/entity-id";

export function CreateCustomerDialog() {
  const [open, setOpen] = useState(false);
  const [request, setRequest] = useState<PutRequest>({
    id: createEntityId()!.toString(),
    name: "",
  });
  const [put, { isLoading, error, isSuccess, reset }] =
    useCustomersCustomerPutMutation();

  useEffect(() => {
    if (isSuccess) {
      reset();
      setOpen(false);
      setRequest({
        id: createEntityId()!.toString(),
        name: "",
      });
    }
  }, [isSuccess, reset]);

  const doUpdate = () => {
    if (isLoading) return;
    put(request);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button size="sm">
          <Plus />
          <span>{t("Neuen Kunden anlegen")}</span>
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("Neuen Kunden anlegen")}</DialogTitle>
          <DialogDescription>
            {t("Hier können Sie neue Kunden anlegen.")}
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4">
          <TextInput
            label={t("Name")}
            placeholder={t("Name")}
            text={request?.name || ""}
            onTextChange={(name) => setRequest((r) => ({ ...r!, name }))}
            field="name"
            errors={null}
          />
        </div>
        <RTKQueryErrorAlert error={error} />
        <CommonDialogFooter isLoading={isLoading} onClickAction={doUpdate} />
      </DialogContent>
    </Dialog>
  );
}
